<section class="mobileInstructions">
    <div class="backgroundImage" [lazyload]="backgroundImage" role="presentation" alt="" tabindex="-1">
        <div class="description">
            <img  [cache]="csp.imagePrefix() + content?.citishopLogoPath" [lazyload]="csp.imagePrefix() + content?.citishopLogoPath"
            role="presentation" alt="" aria-hidden="true" tabindex="-1">
            <p *ngIf="displayChromeMsg" class="mobileInstructions__text" [innerHTML]="content?.chrome | safeHtml" 
            (click)="onTaggingCall($event)"
            (keyup.Enter)="onTaggingCall($event)"></p>
            <p *ngIf="!displayChromeMsg" class="mobileInstructions__text" [innerHTML]="content?.edgeAndSafari | safeHtml"></p>
            <button type="button" cdsButton="primary" cdsButton (click)="onTaggingCall($event);" *ngIf="displayEnrollmentBtn">
                {{content?.btnCopyEnrollmentLinkText}}
            </button>
        </div>
    </div>
</section>
